<div
  class="ds-card w-100"
  [class.disabled]="disabled"
  [class.loading]="loading"
  [class.ds-card--no-highlight]="hideFocusHighlight"
  [class]="'ds-card--' + align"
  [attr.tabindex]="hideFocusHighlight ? null : 0"
>
  <div class="content w-100">
    <ng-content></ng-content>
  </div>
  <div class="loader-overlay w-100" *ngIf="loading">
    <ds-loader></ds-loader>
  </div>
</div>
